module.exports = __webpack_public_path__ + "static/img/IMG_20241123_110346.8197693a.jpg";